import React, { useContext as useContextCore } from 'react'
import { queries } from './graphql'
import { useList } from '@ztechapps/common.hook'

const context = React.createContext(null)
const CoreProvider = context.Provider

export const Provider = ({ children, ...props }) => {
  const filter = { status: 'Active', tags: { $nin: ['use-and-care'] } }
  const sort = { updatedAt: -1 as const }

  const listResult = useList({
    ...queries.allConfig,
    filter,
    sort,
  })
  return <CoreProvider value={{ ...props, ...listResult, sort, filter }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
